import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../../models/chips-and-fields';

@Component({
  selector: 'app-input-standard',
  templateUrl: './inputStandard.component.html',
  styleUrls: ['./inputStandard.component.css']
})
export class InputStandardComponent implements OnInit {

  @Input() public field: Field;
  @Input() public parentFormGroup: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
